import { Base } from "../core/base.model";
import { Tickets } from "./tickets.model";

export class TicketMejora extends Base {
    id_ticket_mejora: number;
    ticket: Tickets;
    area_proyecto_aplica: string;
}